export default "__VITE_ASSET__uip$kp$Q__"